import * as yup from 'yup';
import { InferType } from 'yup';

export const labelsFilterSchema = yup.object({
  labels: yup.array().of(
    yup
      .object({
        key: yup.string(),
        value: yup.array().when('key', (values, schema) => {
          const key = values?.[0];
          if (!key?.length) {
            return schema.of(yup.string());
          }
          return schema
            .of(yup.string().required())
            .min(1, 'At least 1 value is required');
        }),
      })
      .required()
  ),
});

export type LabelsFilterSchema = InferType<typeof labelsFilterSchema>;
